import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../../';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { Packaging } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface PackagingModel {
  packagingMap: Record<string, Packaging>;
  setPackaging: Action<PackagingModel, Packaging[]>;
  setPackage: Action<PackagingModel, Packaging>;
  fetchPackagingLoading: boolean;
  setFetchPackagingLoading: Action<PackagingModel, boolean>;
  fetchPackaging: Thunk<PackagingModel, void, Injections, StoreModel, Promise<void>>;
  fetchPackagingFailure: Action<PackagingModel, ApplicationErrorOptions>;
}

export const packagingModel: PackagingModel = {
  packagingMap: {},
  setPackaging: action((state, packaging) => {
    const packagingMap = packaging.reduce<Record<string, Packaging>>((acc, curr) => {
      acc[curr.packagingId] = curr;
      return acc;
    }, {});
    state.packagingMap = packagingMap;
  }),
  setPackage: action((state, packageAsset) => {
    state.packagingMap[packageAsset.packagingId] = packageAsset;
  }),
  fetchPackagingLoading: false,
  setFetchPackagingLoading: action((state, isLoading) => {
    state.fetchPackagingLoading = isLoading;
  }),
  fetchPackaging: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchPackagingLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchPackaging();
      actions.setPackaging(response);
      actions.setFetchPackagingLoading(false);
      return response;
    } catch (error) {
      actions.fetchPackagingFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchPackagingLoading(false);
      return error;
    }
  }),
  fetchPackagingFailure: action((state, error) => {
    console.error(error);
  }),
};

export default packagingModel;
